import { Box, Heading, Stack, Text } from "@biblioteksentralen/react";
import { EditableDocument } from "@libry-content/common";
import { Edit } from "./editInSanity/EditInSanity";
import { SanityImageSrc } from "./images/SanityImageCore";
import { SanityImageWithResponsiveSize } from "./images/SanityImageWithResponsiveSize";

type Props = {
  title?: string;
  subtitle?: string;
  badges?: React.ReactNode;
  teaser?: string;
  document: EditableDocument;
  sanityImage?: SanityImageSrc;
  cusommImage?: React.ReactNode;
};

export const ArticleHeader = (props: Props) => (
  <Stack spacing="1rem" marginBottom="2rem">
    <Box>
      <Heading as="h1">{props.title}</Heading>
      {props?.subtitle && <Text fontWeight={600}>{props.subtitle}</Text>}
      {props.badges}
    </Box>
    <Edit doc={props.document} />
    <Text fontSize="xl" maxWidth="30em">
      {props.teaser}
    </Text>
    {props.sanityImage?.asset && (
      <SanityImageWithResponsiveSize
        image={props.sanityImage}
        aspectRatio={1.95}
        resolution={{ base: 540, sm: 1080, lg: 2160 }}
      />
    )}
    {props.cusommImage}
  </Stack>
);
